export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    borderColor: "#006B65",
    minHeight: "35px",
    minWidth: "300px",
    height: "35px",
    marginBottom: "10px",
    zIndex: 0,
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: "35px",
    padding: "0px",
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px",
    padding: "0px",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "35px",
    backgroundColor: "#006B65",
  }),
};

export const customDialStyles = {
  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    borderColor: "#006B65",
    minHeight: "35px",
    minWidth: "120px",
    marginLeft: "-10px",
    marginTop: "7px",
    height: "35px",
    zIndex: 50,
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: "35px",
    padding: "0 6px",
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "35px",
    backgroundColor: "#006B65",
  }),
};